const handleCartOffsetTop = () => {
  const $headerBar = $('.header__bar');

  if ($headerBar.length === 0) {
    return;
  }

  const offsetTop = $headerBar.outerHeight();
  const $cartDrawer = $('.cart-drawer');

  $cartDrawer
    .css('top', offsetTop);
}

$(window).on('load', function() {
  handleCartOffsetTop();
});

$(window).on('shopify:section:load', function(event) {
  handleCartOffsetTop();
});
